/* Novaurum theme – store features (cart gifts, discount box, upsells, product page blocks, sections). */
(function () {
  'use strict';

  const NV = (window.NV = window.NV || {});
  const ROUTES = () => window.routes || {};
  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  /* ---------- helpers ---------- */

  NV.money = function (cents) {
    const format = window.nvMoneyFormat || '${{amount}}';
    const value = (Number(cents) || 0) / 100;
    const fmt = (n, dec, thousands, decimal) => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals':
          return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return fmt(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return fmt(value, 2, "'", '.');
        default:
          return fmt(value, 2, ',', '.');
      }
    });
  };

  NV.json = function (url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    }).then((res) => res.json().then((data) => (res.ok ? data : Promise.reject(data))));
  };

  NV.getCart = () => NV.json(`${ROUTES().cart_url || '/cart'}.js`);
  NV.drawer = () => document.querySelector('cart-drawer');
  NV.onCartPage = () => !!document.getElementById('main-cart-items');

  /* Re-render the cart drawer + bubble without changing whether the drawer is open. */
  NV.refreshCart = function () {
    if (NV.onCartPage()) {
      window.location.reload();
      return Promise.resolve();
    }
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(`${root}?sections=${SECTIONS.join(',')}`)
      .then((res) => res.json())
      .then((sections) => NV.paintSections(sections, false));
  };

  NV.paintSections = function (sections, open) {
    const drawer = NV.drawer();
    if (!drawer || !sections) return;
    const parse = (html, selector) => new DOMParser().parseFromString(html, 'text/html').querySelector(selector);

    if (sections['cart-drawer']) {
      const fresh = parse(sections['cart-drawer'], '#CartDrawer');
      const target = document.getElementById('CartDrawer');
      if (fresh && target) target.innerHTML = fresh.innerHTML;
      drawer.classList.toggle('is-empty', !!(fresh && fresh.querySelector('.drawer__inner-empty')));
      const overlay = document.getElementById('CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', () => drawer.close());
    }
    if (sections['cart-icon-bubble']) {
      const bubble = document.getElementById('cart-icon-bubble');
      const fresh = parse(sections['cart-icon-bubble'], '.shopify-section');
      if (bubble && fresh) bubble.innerHTML = fresh.innerHTML;
    }
    if (open) drawer.open();
  };

  /* Add one or more lines, then show the drawer (or go to /cart). */
  NV.addItems = function (items, opts = {}) {
    const body = { items };
    if (NV.drawer()) {
      body.sections = SECTIONS;
      body.sections_url = window.location.pathname;
    }
    return NV.json(`${ROUTES().cart_add_url || '/cart/add'}.js`, body).then((res) => {
      if (opts.silent) return res;
      if (!NV.drawer() || NV.onCartPage()) {
        window.location = ROUTES().cart_url || '/cart';
        return res;
      }
      NV.paintSections(res.sections, true);
      if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nv', cartData: res });
      return res;
    });
  };

  const store = (kind) => ({
    get(k, fallback) {
      try {
        const v = window[kind].getItem(k);
        return v === null ? fallback : JSON.parse(v);
      } catch (e) {
        return fallback;
      }
    },
    set(k, v) {
      try {
        window[kind].setItem(k, JSON.stringify(v));
      } catch (e) {
        /* storage blocked – features still work, just without memory */
      }
    },
  });
  NV.session = store('sessionStorage');
  NV.local = store('localStorage');

  const showError = (err) => alert((err && (err.description || err.message)) || window.cartStrings.error);

  /* ---------- free gift manager ----------
     Gift lines carry the hidden line property _nv_gift:
       "spend:<rule>"           – unlocked by cart subtotal (rules from theme settings)
       "qty:<productId>:<min>"  – unlocked by buying <min> of a product (quantity breaks block)
     The theme only adds/removes the line. The $0 price comes from a Shopify discount
     (Buy X get Y, or an automatic discount on the gift product). */

  const Gifts = (NV.gifts = {
    busy: false,
    queued: false,

    qtyTiers() {
      return NV.local.get('nv_qty_tiers', {});
    },

    registerQtyTiers(productId, tiers) {
      const all = this.qtyTiers();
      if (tiers.length) all[productId] = tiers;
      else delete all[productId];
      NV.local.set('nv_qty_tiers', all);
    },

    sync() {
      if (this.busy) {
        this.queued = true;
        return Promise.resolve();
      }
      this.busy = true;
      return NV.getCart()
        .then((cart) => this.apply(cart))
        .catch((e) => console.warn('[nv gifts]', e))
        .finally(() => {
          this.busy = false;
          if (this.queued) {
            this.queued = false;
            this.sync();
          }
        });
    },

    apply(cart) {
      // _gift is the property the previous store script used for the REST mask; treat it the same way
      const giftId = (i) =>
        (i.properties && i.properties._nv_gift) ||
        (i.properties && i.properties._gift && `code:${String(i.properties._gift).toUpperCase()}`) ||
        null;
      const paid = cart.items.filter((i) => !giftId(i));
      const subtotal = paid.reduce((sum, i) => sum + i.final_line_price, 0);
      const qtyOf = (pid) =>
        paid.filter((i) => String(i.product_id) === String(pid)).reduce((s, i) => s + i.quantity, 0);
      const knownTiers = this.qtyTiers();
      const wanted = {};

      if (paid.length) {
        (window.nvSpendGifts || []).forEach((rule) => {
          if (rule.variant && subtotal >= rule.threshold) wanted[`spend:${rule.id}`] = rule.variant;
        });
      }
      Object.keys(knownTiers).forEach((pid) => {
        knownTiers[pid].forEach((t) => {
          if (t.variant && qtyOf(pid) >= t.min) wanted[`qty:${pid}:${t.min}`] = t.variant;
        });
      });

      // Gifts unlocked by a discount code (e.g. REST + comforter -> free eye mask).
      // When window.nvAutoGift is on, the same rules fire automatically as soon as a
      // trigger product is in the cart, with no code typed. The code still works too.
      const codes = (cart.discount_codes || []).map((d) => String(d.code).toUpperCase());
      const auto = window.nvAutoGift === true;
      (window.nvCodeGifts || []).forEach((rule) => {
        if (!rule.variant || (!auto && !codes.includes(rule.code))) return;
        const triggered = rule.triggers.length
          ? rule.triggers.some((pid) => qtyOf(pid) > 0)
          : paid.length > 0;
        if (triggered) wanted[`code:${rule.code}`] = rule.variant;
      });

      // One gift line per unique gift VARIANT. A product may be wanted by several
      // rules at once (spend + qty tier + code) but the shopper should get it once.
      // The first rule that asked for a variant becomes its representative id.
      const repOfVariant = {};
      Object.keys(wanted).forEach((id) => {
        const v = String(wanted[id]);
        if (!(v in repOfVariant)) repOfVariant[v] = id;
      });

      const declined = NV.session.get('nv_gift_declined', []);
      const lastSeen = NV.session.get('nv_gift_seen', []);
      const present = {};
      const keptVariant = {};
      const updates = {};

      cart.items.forEach((item) => {
        const id = giftId(item);
        if (!id) return;
        const v = String(item.variant_id);
        let rep = repOfVariant[v] || null;
        // Tier gift whose product still qualifies but whose tiers aren't registered
        // on this device: fall back to the rule encoded in the line's own id.
        if (!rep && id.startsWith('qty:')) {
          const [, pid, min] = id.split(':');
          if (!(pid in knownTiers) && qtyOf(pid) >= Number(min)) rep = id;
        }
        if (!rep || keptVariant[v]) {
          // not wanted any more, or a duplicate of a gift variant already kept
          updates[item.key] = 0;
        } else {
          keptVariant[v] = true;
          present[rep] = true;
          if (item.quantity !== 1) updates[item.key] = 1;
        }
      });

      // A gift that was in the cart last time, still qualifies, but is gone now -> removed by shopper.
      Object.keys(repOfVariant).forEach((v) => {
        const id = repOfVariant[v];
        if (lastSeen.includes(id) && !present[id] && !declined.includes(id)) declined.push(id);
      });
      Object.keys(present).forEach((id) => {
        const i = declined.indexOf(id);
        if (i > -1) declined.splice(i, 1);
      });

      const adds = Object.keys(repOfVariant)
        .map((v) => repOfVariant[v])
        .filter((id) => !present[id] && !declined.includes(id))
        .map((id) => ({ id: Number(wanted[id]), quantity: 1, properties: { _nv_gift: id } }));

      NV.session.set('nv_gift_declined', declined);
      NV.session.set('nv_gift_seen', Object.keys(present).concat(adds.map((a) => a.properties._nv_gift)));

      if (!Object.keys(updates).length && !adds.length) return;
      let chain = Promise.resolve();
      if (Object.keys(updates).length) {
        chain = chain.then(() => NV.json(`${ROUTES().cart_update_url || '/cart/update'}.js`, { updates }));
      }
      if (adds.length) {
        chain = chain.then(() =>
          NV.json(`${ROUTES().cart_add_url || '/cart/add'}.js`, { items: adds }).catch((e) =>
            console.warn('[nv gifts] gift could not be added', e)
          )
        );
      }
      return chain.then(() => NV.refreshCart());
    },
  });

  let giftTimer;
  const scheduleGiftSync = () => {
    clearTimeout(giftTimer);
    giftTimer = setTimeout(() => Gifts.sync(), 350);
  };

  /* ---------- delegated cart actions (drawer upsells, discount box) ---------- */

  document.addEventListener('click', (e) => {
    const add = e.target.closest('[data-nv-add]');
    if (add) {
      e.preventDefault();
      if (add.getAttribute('aria-disabled') === 'true') return;
      add.classList.add('loading');
      add.setAttribute('aria-disabled', 'true');
      NV.addItems([{ id: Number(add.dataset.nvAdd), quantity: 1 }])
        .catch(showError)
        .finally(() => {
          add.classList.remove('loading');
          add.removeAttribute('aria-disabled');
        });
      return;
    }

    const removeCode = e.target.closest('[data-nv-remove-code]');
    if (removeCode) {
      e.preventDefault();
      const box = removeCode.closest('[data-nv-discount]');
      const codes = (box.dataset.codes || '')
        .split(',')
        .filter((c) => c && c !== removeCode.dataset.nvRemoveCode);
      NV.setDiscounts(codes, box);
    }
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-nv-discount-form]');
    if (!form) return;
    e.preventDefault();
    const box = form.closest('[data-nv-discount]');
    const code = form.querySelector('input').value.trim();
    if (!code) return;
    const codes = (box.dataset.codes || '').split(',').filter(Boolean);
    if (!codes.map((c) => c.toLowerCase()).includes(code.toLowerCase())) codes.push(code);
    NV.setDiscounts(codes, box, code);
  });

  NV.setDiscounts = function (codes, box, tried) {
    box.classList.add('is-loading');
    const flag = (selector) => {
      const msg = document.querySelector(`${selector} [data-nv-discount-msg]`);
      if (msg) msg.textContent = msg.dataset.invalid;
    };
    // Add any gift the code unlocks first: a Buy X get Y code only becomes "applicable" once its gift is in the cart.
    return NV.json(`${ROUTES().cart_update_url || '/cart/update'}.js`, { discount: codes.join(',') })
      .then(() => Gifts.sync())
      .then(() => NV.getCart())
      .then((cart) => {
        const bad =
          tried &&
          (cart.discount_codes || []).find((d) => d.code.toLowerCase() === tried.toLowerCase() && !d.applicable);
        return NV.refreshCart().then(() => bad && flag('[data-nv-discount]'));
      })
      .catch(() => flag('[data-nv-discount]'))
      .finally(() => box.classList.remove('is-loading'));
  };

  /* ---------- product page: quantity breaks ---------- */

  class NvQtyBreaks extends HTMLElement {
    connectedCallback() {
      this.section = this.dataset.section;
      this.picks = this.dataset.picks === '1';
      this.bxgy = this.dataset.bxgy === '1';
      this.ownInput = this.querySelector('input[name="quantity"]');

      const standard = document.getElementById(`Quantity-${this.section}`);
      if (standard) {
        this.ownInput && this.ownInput.remove();
        this.ownInput = null;
        this.standard = standard;
        const wrap = document.getElementById(`Quantity-Form-${this.section}`);
        if (wrap) wrap.hidden = true;
      }

      const tierData = JSON.parse(this.querySelector('.nv-qb__tiers-data').textContent);
      Gifts.registerQtyTiers(
        this.dataset.product,
        tierData.filter((t) => t.gift).map((t) => ({ min: t.qty, variant: t.gift }))
      );

      if (this.picks) {
        const vd = this.querySelector('.nv-qb__vdata');
        this.variants = vd ? JSON.parse(vd.textContent) : [];
        const mainPicker = document.getElementById(`variant-selects-${this.section}`);
        if (mainPicker) mainPicker.hidden = true;
        this.addEventListener('change', (e) => {
          if (e.target.tagName === 'SELECT') {
            e.stopPropagation();
            const item = e.target.closest('.nv-qb__sel-item');
            if (item) this.showMedia(this.resolveItem(item));
            this.repriceActive();
          }
        });
        this.bindAddButton();
      }

      this.addEventListener('change', (e) => {
        if (e.target.name === `nv-qb-${this.section}`) this.select(Number(e.target.value));
      });
      const checked = this.querySelector('input[type="radio"]:checked');
      if (checked) this.select(Number(checked.value));

      if (typeof subscribe === 'function') {
        this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const d = event.data;
          if (d.sectionId === this.section && d.variant && !this.picks) this.reprice(d.variant.price, d.variant.compare_at_price);
        });
      }
    }

    disconnectedCallback() {
      this.unsub && this.unsub();
    }

    showMedia(v) {
      if (!v || v.fm == null) return;
      const gallery = document.getElementById(`MediaGallery-${this.section}`);
      if (gallery && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(`${this.section}-${v.fm}`, true);
      }
    }

    activeTier() {
      return this.querySelector('.nv-qb__tier.is-active');
    }

    activeItems() {
      const t = this.activeTier();
      return t ? Array.from(t.querySelectorAll('.nv-qb__sel-item')) : [];
    }

    select(qty) {
      if (this.ownInput) this.ownInput.value = qty;
      if (this.standard) this.standard.value = qty;
      this.querySelectorAll('.nv-qb__tier').forEach((el) =>
        el.classList.toggle('is-active', Number(el.dataset.qty) === qty)
      );
      if (this.picks) this.repriceActive();
    }

    resolveItem(item) {
      if (!this.variants || !this.variants.length) return null;
      const picked = Array.from(item.querySelectorAll('select')).map((s) => s.value);
      return (
        this.variants.find((v) => v.o.length === picked.length && v.o.every((val, i) => val === picked[i])) || null
      );
    }

    // recompute the ACTIVE tier price from the chosen per-item variants
    repriceActive() {
      const tier = this.activeTier();
      if (!tier) return;
      const qty = Number(tier.dataset.qty) || 1;
      const off = Number(tier.dataset.off) || 0;
      const items = this.activeItems();
      if (!items.length) return;
      let base = 0;
      let cmp = 0;
      let ok = true;
      items.forEach((item) => {
        const v = this.resolveItem(item);
        if (v) {
          base += v.p;
          cmp += v.c && v.c > v.p ? v.c : v.p;
        } else ok = false;
      });
      if (!ok || !base) return;
      let now;
      if (this.bxgy && items.length > 1 && off > 0) {
        const sorted = items
          .map((it) => { const r = this.resolveItem(it); return r ? r.p : 0; })
          .sort((a, b) => a - b);
        const discSum = sorted.slice(0, items.length - 1).reduce((s, p) => s + p, 0);
        now = Math.round(base - (discSum * off) / 100);
      } else {
        now = Math.round(base * (1 - off / 100));
      }
      const cmpTotal = off > 0 ? base : cmp;
      const set = (sel, text, hide) => {
        const node = tier.querySelector(sel);
        if (!node) return;
        node.textContent = text;
        if (hide !== undefined) node.hidden = hide;
      };
      set('[data-nv-price]', NV.money(now));
      set('[data-nv-compare]', NV.money(cmpTotal), cmpTotal <= now);
      set('[data-nv-each]', NV.money(Math.round(now / qty)));
    }

    bindAddButton() {
      const btn = document.getElementById(`ProductSubmitButton-${this.section}`);
      if (!btn) return;
      this.addBtn = btn;
      btn.addEventListener(
        'click',
        (e) => {
          if (!this.picks) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          this.addBundle();
        },
        true
      );
    }

    addBundle() {
      const items = [];
      let bad = false;
      this.activeItems().forEach((item) => {
        const v = this.resolveItem(item);
        if (!v || !v.a) {
          bad = true;
          return;
        }
        items.push({ id: v.id, quantity: 1 });
      });
      if (bad || !items.length) {
        alert((window.variantStrings && window.variantStrings.unavailable) || 'Please choose available options.');
        return;
      }
      const addons = typeof addonsFor === 'function' ? addonsFor(this.section) : [];
      const all = items.concat(addons);
      const btn = this.addBtn;
      if (btn) {
        btn.classList.add('loading');
        btn.setAttribute('aria-disabled', 'true');
      }
      NV.addItems(all)
        .catch(showError)
        .finally(() => {
          if (btn) {
            btn.classList.remove('loading');
            btn.removeAttribute('aria-disabled');
          }
        });
    }

    reprice(unitCents, unitCompare) {
      const cmpUnit = unitCompare && unitCompare > unitCents ? unitCompare : unitCents;
      this.querySelectorAll('.nv-qb__tier').forEach((el) => {
        const qty = Number(el.dataset.qty);
        const off = Number(el.dataset.off) || 0;
        const base = unitCents * qty;
        let now;
        if (this.bxgy && qty > 1 && off > 0) {
          now = Math.round(base - (unitCents * (qty - 1) * off) / 100);
        } else {
          now = Math.round(base * (1 - off / 100));
        }
        const cmpTotal = off > 0 ? base : cmpUnit * qty;
        const set = (sel, text, hide) => {
          const node = el.querySelector(sel);
          if (!node) return;
          node.textContent = text;
          if (hide !== undefined) node.hidden = hide;
        };
        set('[data-nv-price]', NV.money(now));
        set('[data-nv-compare]', NV.money(cmpTotal), cmpTotal <= now);
        set('[data-nv-each]', NV.money(Math.round(now / qty)));
      });
    }
  }
  customElements.get('nv-qty-breaks') || customElements.define('nv-qty-breaks', NvQtyBreaks);

  /* ---------- product page: add-on checkboxes (added together with the main product) ---------- */

  const addonsFor = (sectionId) =>
    Array.from(document.querySelectorAll(`[data-nv-addon][data-section="${sectionId}"]:checked`)).map((el) => ({
      id: Number(el.value),
      quantity: 1,
    }));

  /* ---------- upsell card: pick variant from the option dropdowns ---------- */

  class NvUpsellCard extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('script[type="application/json"]');
      if (!data) return;
      this.variants = JSON.parse(data.textContent);
      this.addEventListener('change', (e) => { e.stopPropagation(); this.update(); });
    }
    update() {
      const picked = Array.from(this.querySelectorAll('select')).map((s) => s.value);
      const v = this.variants.find((x) => x.o.every((val, i) => val === picked[i]));
      const btn = this.querySelector('[data-nv-add]');
      if (!v) {
        btn.disabled = true;
        return;
      }
      btn.dataset.nvAdd = v.id;
      btn.disabled = !v.a;
      this.querySelector('[data-nv-price]').textContent = NV.money(v.p);
      const c = this.querySelector('[data-nv-compare]');
      c.textContent = NV.money(v.c);
      c.hidden = !(v.c > v.p);
    }
  }
  customElements.get('nv-upsell-card') || customElements.define('nv-upsell-card', NvUpsellCard);

  /* ---------- cart line: change color/size right in the cart ----------
     The Ajax cart cannot swap a line's variant, so the new variant is added first
     (keeping quantity and line properties) and the old line is removed after it succeeds. */

  class NvLineVariant extends HTMLElement {
    connectedCallback() {
      // stop here: Dawn's <cart-items> treats every bubbling change event as a quantity edit
      this.addEventListener('change', (e) => {
        e.stopPropagation();
        this.swap();
      });
    }
    swap() {
      const variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      // Liquid prints an empty property list as [] but the Ajax API only accepts an object
      let props = JSON.parse(this.querySelector('[data-props]').textContent || '{}');
      if (!props || Array.isArray(props)) props = {};
      const picked = Array.from(this.querySelectorAll('select')).map((s) => s.value);
      const v = variants.find((x) => x.o.every((val, i) => val === picked[i]));
      const fail = (msg) => {
        this.classList.remove('is-loading');
        this.classList.add('is-error');
        const row = this.closest('.cart-item');
        const err = row && row.querySelector('.cart-item__error-text');
        if (err) err.textContent = msg;
      };
      const oldVariant = String(this.dataset.variant);
      if (!v || String(v.id) === oldVariant) return;
      if (!v.a) return fail(window.variantStrings ? window.variantStrings.soldOut : 'Sold out');
      this.classList.add('is-loading');
      const qty = Number(this.dataset.qty) || 1;
      const fallbackKey = this.dataset.key;
      // Add the new variant first, then re-read the cart and remove the OLD line
      // using its CURRENT key (robust against stale/mismatched line keys).
      NV.json(`${ROUTES().cart_add_url || '/cart/add'}.js`, { items: [{ id: v.id, quantity: qty, properties: props }] })
        .then(() => NV.getCart())
        .then((cart) => {
          const old = (cart.items || []).find((it) => String(it.variant_id) === oldVariant);
          const key = old ? old.key : fallbackKey;
          return NV.json(`${ROUTES().cart_change_url || '/cart/change'}.js`, { id: key, quantity: 0 });
        })
        .then((cart) => {
          if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nv', cartData: cart });
          return NV.refreshCart();
        })
        .catch((err) => fail((err && (err.description || err.message)) || window.cartStrings.error));
    }
  }
  customElements.get('nv-line-variant') || customElements.define('nv-line-variant', NvLineVariant);

  /* ---------- product page: bundle / frequently bought together ---------- */

  class NvBundle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-nv-bundle-add]');
      this.addEventListener('change', () => this.total());
      this.button && this.button.addEventListener('click', () => this.add());
      this.total();
    }

    rows() {
      return Array.from(this.querySelectorAll('.nv-bundle__item')).filter((row) => {
        const box = row.querySelector('input[type="checkbox"]');
        return !box || box.checked;
      });
    }

    variantOf(row) {
      const select = row.querySelector('select');
      const node = select ? select.selectedOptions[0] : row.querySelector('[data-variant]');
      return { id: Number(select ? select.value : node.dataset.variant), price: Number(node.dataset.price) || 0 };
    }

    total() {
      const rows = this.rows();
      const off = Number(this.dataset.off) || 0;
      const full = rows.reduce((s, r) => s + this.variantOf(r).price, 0);
      const now = Math.round(full * (1 - off / 100));
      const t = this.querySelector('[data-nv-bundle-total]');
      const c = this.querySelector('[data-nv-bundle-compare]');
      if (t) t.textContent = NV.money(now);
      if (c) {
        c.textContent = NV.money(full);
        c.hidden = off <= 0;
      }
      if (this.button) this.button.disabled = rows.length < 2;
    }

    add() {
      const items = this.rows().map((r) => ({ id: this.variantOf(r).id, quantity: 1 }));
      this.button.classList.add('loading');
      NV.addItems(items)
        .catch(showError)
        .finally(() => this.button.classList.remove('loading'));
    }
  }
  customElements.get('nv-bundle') || customElements.define('nv-bundle', NvBundle);

  /* ---------- product page: sticky add to cart ---------- */

  class NvStickyAtc extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      if (this.closest('quick-add-modal')) return this.remove();
      const section = this.dataset.section;
      this.mainButton = document.getElementById(`ProductSubmitButton-${section}`);
      if (!this.mainButton) return;

      const data = this.querySelector('.nv-sticky__data');
      this.variants = data ? JSON.parse(data.textContent) : null;
      this.selects = Array.from(this.querySelectorAll('.nv-sticky__selects select'));
      this.addBtn = this.querySelector('.nv-sticky__add') || this.querySelector('button');
      this.qtyInput = this.querySelector('.nv-sticky__qinput');
      this.current = this.resolve();

      document.body.appendChild(this); // leave the product column so position: fixed is never clipped

      new IntersectionObserver(([entry]) => {
        this.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(this.mainButton);

      // variant dropdowns (stopPropagation: the bar lives inside <body>, but keep it isolated)
      this.selects.forEach((s) =>
        s.addEventListener('change', (e) => {
          e.stopPropagation();
          this.current = this.resolve();
          this.render();
        })
      );

      // quantity stepper
      Array.from(this.querySelectorAll('[data-nv-step]')).forEach((b) =>
        b.addEventListener('click', () => this.step(Number(b.dataset.nvStep)))
      );
      if (this.qtyInput) this.qtyInput.addEventListener('change', () => this.clampQty());

      // add to cart
      if (this.addBtn) this.addBtn.addEventListener('click', () => this.add());

      // keep in sync when the main product variant picker changes
      if (typeof subscribe === 'function') {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const d = event.data;
          if (d.sectionId !== section || !d.variant) return;
          this.syncFromMain(d.variant);
        });
      }
    }

    resolve() {
      if (!this.variants || !this.selects.length) return null;
      const picked = this.selects.map((s) => s.value);
      return (
        this.variants.find((x) => x.o.length === picked.length && x.o.every((val, i) => val === picked[i])) || null
      );
    }

    syncFromMain(variant) {
      if (this.selects.length && variant.options) {
        this.selects.forEach((s, i) => {
          if (variant.options[i] != null) s.value = variant.options[i];
        });
        this.current = this.resolve();
      }
      const price = this.querySelector('[data-nv-price]');
      if (price) price.textContent = NV.money(variant.price);
      const vt = this.querySelector('[data-nv-variant]');
      if (vt) vt.textContent = variant.title === 'Default Title' ? '' : variant.title;
      if (this.addBtn) this.addBtn.disabled = !variant.available;
      this.dataset.variant = variant.id;
    }

    render() {
      const v = this.current;
      const price = this.querySelector('[data-nv-price]');
      const vt = this.querySelector('[data-nv-variant]');
      if (!v) {
        if (this.addBtn) this.addBtn.disabled = true;
        return;
      }
      if (price) price.textContent = NV.money(v.p);
      if (vt) vt.textContent = v.t === 'Default Title' ? '' : v.t;
      if (this.addBtn) this.addBtn.disabled = !v.a;
      this.dataset.variant = v.id;
    }

    step(delta) {
      if (!this.qtyInput) return;
      this.qtyInput.value = Math.max(1, (parseInt(this.qtyInput.value, 10) || 1) + delta);
    }

    clampQty() {
      if (!this.qtyInput) return;
      const n = parseInt(this.qtyInput.value, 10);
      if (!n || n < 1) this.qtyInput.value = 1;
    }

    qty() {
      return this.qtyInput ? Math.max(1, parseInt(this.qtyInput.value, 10) || 1) : 1;
    }

    add() {
      // plain bar (no pickers): reuse the main button so bundles / quantity breaks still apply
      if (!this.variants && !this.qtyInput) {
        this.mainButton.click();
        return;
      }
      let id;
      let available = true;
      if (this.variants) {
        const v = this.current || this.resolve();
        if (v) {
          id = v.id;
          available = v.a;
        } else {
          id = Number(this.dataset.variant);
        }
      } else {
        id = Number(this.dataset.variant);
      }
      if (!id || !available) return;
      const btn = this.addBtn;
      if (btn) {
        btn.classList.add('loading');
        btn.setAttribute('aria-disabled', 'true');
      }
      NV.addItems([{ id: id, quantity: this.qty() }])
        .catch(showError)
        .finally(() => {
          if (btn) {
            btn.classList.remove('loading');
            btn.removeAttribute('aria-disabled');
          }
        });
    }
  }
  customElements.get('nv-sticky-atc') || customElements.define('nv-sticky-atc', NvStickyAtc);

  /* ---------- countdown (real end date only – no fake evergreen timers) ---------- */

  class NvCountdown extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end);
      if (isNaN(this.end)) return;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
    tick() {
      const left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
      if (!left) {
        clearInterval(this.timer);
        if (this.dataset.hideOnEnd === 'true') (this.closest('[data-nv-countdown-wrap]') || this).hidden = true;
      }
      const parts = {
        d: Math.floor(left / 86400),
        h: Math.floor((left % 86400) / 3600),
        m: Math.floor((left % 3600) / 60),
        s: left % 60,
      };
      Object.keys(parts).forEach((k) => {
        const el = this.querySelector(`[data-${k}]`);
        if (el) el.textContent = String(parts[k]).padStart(2, '0');
      });
    }
  }
  customElements.get('nv-countdown') || customElements.define('nv-countdown', NvCountdown);

  /* ---------- before / after slider ---------- */

  class NvBeforeAfter extends HTMLElement {
    connectedCallback() {
      const range = this.querySelector('input[type="range"]');
      const set = () => this.style.setProperty('--nv-pos', `${range.value}%`);
      range.addEventListener('input', set);
      set();
    }
  }
  customElements.get('nv-before-after') || customElements.define('nv-before-after', NvBeforeAfter);

  /* ---------- tabs ---------- */

  class NvTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.show(i));
        tab.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          const next = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.show(next);
          this.tabs[next].focus();
        });
      });
    }
    show(index) {
      this.tabs.forEach((tab, i) => {
        const on = i === index;
        tab.setAttribute('aria-selected', on);
        tab.tabIndex = on ? 0 : -1;
        document.getElementById(tab.getAttribute('aria-controls')).hidden = !on;
      });
    }
  }
  customElements.get('nv-tabs') || customElements.define('nv-tabs', NvTabs);

  /* ---------- promo popup ---------- */

  class NvPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.key = `nv_popup_${this.dataset.id}`;
      const days = Number(this.dataset.days) || 0;
      const last = NV.local.get(this.key, 0);
      const inEditor = window.Shopify && Shopify.designMode;

      this.querySelectorAll('[data-nv-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      this.dialog.addEventListener('click', (e) => e.target === this.dialog && this.close());
      this.dialog.addEventListener('cancel', () => NV.local.set(this.key, Date.now()));
      const copy = this.querySelector('[data-nv-copy]');
      copy &&
        copy.addEventListener('click', () => {
          navigator.clipboard && navigator.clipboard.writeText(copy.dataset.nvCopy);
          copy.classList.add('is-copied');
        });

      if (inEditor) {
        if (this.dataset.preview === 'true') this.dialog.showModal();
        return;
      }
      if (last && Date.now() - last < days * 86400000) return;
      setTimeout(() => this.dialog.isConnected && this.dialog.showModal(), (Number(this.dataset.delay) || 0) * 1000);
    }
    close() {
      NV.local.set(this.key, Date.now());
      this.dialog.close();
    }
  }
  customElements.get('nv-popup') || customElements.define('nv-popup', NvPopup);

  /* ---------- stories ---------- */

  class NvStories extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.slides = Array.from(this.querySelectorAll('.nv-stories__slide'));
      this.bars = Array.from(this.querySelectorAll('.nv-stories__bar span'));
      this.querySelectorAll('[data-nv-story]').forEach((btn) =>
        btn.addEventListener('click', () => this.open(Number(btn.dataset.nvStory)))
      );
      this.querySelector('[data-nv-prev]').addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-nv-next]').addEventListener('click', () => this.go(this.index + 1));
      this.querySelector('[data-nv-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => this.stop());
    }
    open(i) {
      this.dialog.showModal();
      this.go(i);
    }
    stop() {
      clearTimeout(this.timer);
      this.slides.forEach((s) => {
        const v = s.querySelector('video');
        if (v) v.pause();
      });
    }
    go(i) {
      if (i < 0) i = 0;
      if (i >= this.slides.length) return this.dialog.close();
      this.stop();
      this.index = i;
      this.slides.forEach((s, n) => (s.hidden = n !== i));
      this.bars.forEach((b, n) => {
        b.style.transition = 'none';
        b.style.width = n < i ? '100%' : '0';
      });
      const video = this.slides[i].querySelector('video');
      const duration = (Number(this.dataset.seconds) || 5) * 1000;
      const bar = this.bars[i];
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          if (video) {
            video.currentTime = 0;
            video.play().catch(() => {});
            video.onended = () => this.go(i + 1);
            video.ontimeupdate = () => {
              if (bar && video.duration) bar.style.width = `${(video.currentTime / video.duration) * 100}%`;
            };
          } else {
            if (bar) {
              bar.style.transition = `width ${duration}ms linear`;
              bar.style.width = '100%';
            }
            this.timer = setTimeout(() => this.go(i + 1), duration);
          }
        })
      );
    }
  }
  customElements.get('nv-stories') || customElements.define('nv-stories', NvStories);

  /* ---------- video reels: play only what is on screen, tap for sound ---------- */

  class NvReels extends HTMLElement {
    connectedCallback() {
      const videos = Array.from(this.querySelectorAll('video'));
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) e.target.play().catch(() => {});
            else e.target.pause();
          });
        },
        { threshold: 0.5 }
      );
      videos.forEach((v) => io.observe(v));
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('.nv-reels__sound');
        if (!btn) return;
        const video = btn.parentElement.querySelector('video');
        const unmute = video.muted;
        videos.forEach((v) => (v.muted = true));
        this.querySelectorAll('.nv-reels__sound').forEach((b) => (b.textContent = '🔇'));
        video.muted = !unmute;
        btn.textContent = unmute ? '🔊' : '🔇';
      });
    }
  }
  customElements.get('nv-reels') || customElements.define('nv-reels', NvReels);

  /* ---------- shoppable image hotspots ---------- */

  document.addEventListener('click', (e) => {
    const dot = e.target.closest('.nv-hotspot__dot');
    document.querySelectorAll('.nv-hotspot.is-open').forEach((h) => {
      if (!dot || h !== dot.parentElement) h.classList.remove('is-open');
    });
    if (dot) dot.parentElement.classList.toggle('is-open');
  });

  /* ---------- scroll to top ---------- */

  const initScrollTop = () => {
    const btn = document.querySelector('.nv-scroll-top');
    if (!btn) return;
    const toggle = () => btn.classList.toggle('is-visible', window.scrollY > 600);
    window.addEventListener('scroll', toggle, { passive: true });
    btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    toggle();
  };

  /* ---------- boot ---------- */

  const boot = () => {
    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'product-form' && event.productVariantId) {
          const input = document.querySelector(`product-form input[name="id"][value="${event.productVariantId}"]`);
          const sectionId = input && input.closest('product-form').dataset.sectionId;
          const addons = sectionId ? addonsFor(sectionId) : [];
          if (addons.length) {
            NV.addItems(addons, { silent: true })
              .catch(showError)
              .then(() => NV.refreshCart())
              .then(scheduleGiftSync);
            return;
          }
        }
        scheduleGiftSync();
      });
    }
    initScrollTop();
    scheduleGiftSync();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
